import { render, staticRenderFns } from "./retailship.vue?vue&type=template&id=77174373&scoped=true"
import script from "./retailship.vue?vue&type=script&lang=js"
export * from "./retailship.vue?vue&type=script&lang=js"
import style0 from "./retailship.vue?vue&type=style&index=0&id=77174373&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77174373",
  null
  
)

export default component.exports